import IconRound from 'assets/logos/icon-round.svg?react';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';

export type LogoProps = {
  size?: 'default' | 'large';
};

const Logo: React.FC<LogoProps> = ({ size = 'default' }) => {
  const navigate = useNavigate();

  const goToHome = () => navigate(routes.home.route);

  const dimensions = () => {
    switch (size) {
      case 'large':
        return 100;

      case 'default':
      default:
        return 50;
    }
  };

  return (
    /*
     * A real `button`, not an `svg` with an `onClick`. This navigates home, so it
     * is a control: it needs a role, an accessible name and keyboard focus, none
     * of which a bare inline SVG has. It used to be an antd `Image` with
     * `alt="logo"`, which at least gave it a name — replacing that with the new
     * brand icon quietly turned it into a click target no keyboard or screen
     * reader could reach.
     *
     * The chrome is stripped so it stays visually identical to the plain SVG.
     */
    <button
      type="button"
      aria-label="Gynger"
      onClick={goToHome}
      className="inline-flex cursor-pointer border-none bg-transparent p-0 text-foreground"
    >
      {/* Decorative: the button already carries the name. */}
      <IconRound aria-hidden fill="currentColor" height={dimensions()} width={dimensions()} />
    </button>
  );
};

export default Logo;
